/**
 * Pexels serves the full-resolution original when the URL carries no query
 * params — several of the ones used on this site are over 3 MB for a card only
 * a few hundred pixels wide. Asking for a width-capped, compressed variant is
 * just a query string.
 *
 * Other hosts (customer-assets.emergentagent.com) have no resizing API, so
 * their URLs are returned untouched.
 */
export function sized(url, width) {
  if (!url || !url.includes("images.pexels.com")) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}auto=compress&cs=tinysrgb&w=${width}`;
}
